__turbopack_context__.v({
  "centerPlay": "NewsArticleVideoPlayer-module-scss-module___mQBsG__centerPlay",
  "centerPlayIcon": "NewsArticleVideoPlayer-module-scss-module___mQBsG__centerPlayIcon",
  "centerPlaySvg": "NewsArticleVideoPlayer-module-scss-module___mQBsG__centerPlaySvg",
  "chrome": "NewsArticleVideoPlayer-module-scss-module___mQBsG__chrome",
  "chromeHidden": "NewsArticleVideoPlayer-module-scss-module___mQBsG__chromeHidden",
  "controls": "NewsArticleVideoPlayer-module-scss-module___mQBsG__controls",
  "controlsLeft": "NewsArticleVideoPlayer-module-scss-module___mQBsG__controlsLeft",
  "controlsRight": "NewsArticleVideoPlayer-module-scss-module___mQBsG__controlsRight",
  "icon": "NewsArticleVideoPlayer-module-scss-module___mQBsG__icon",
  "iconButton": "NewsArticleVideoPlayer-module-scss-module___mQBsG__iconButton",
  "iconButtonDim": "NewsArticleVideoPlayer-module-scss-module___mQBsG__iconButtonDim",
  "loadingBackdrop": "NewsArticleVideoPlayer-module-scss-module___mQBsG__loadingBackdrop",
  "loadingOverlay": "NewsArticleVideoPlayer-module-scss-module___mQBsG__loadingOverlay",
  "loadingSpinner": "NewsArticleVideoPlayer-module-scss-module___mQBsG__loadingSpinner",
  "newsPlayerSpin": "NewsArticleVideoPlayer-module-scss-module___mQBsG__newsPlayerSpin",
  "poster": "NewsArticleVideoPlayer-module-scss-module___mQBsG__poster",
  "posterLayer": "NewsArticleVideoPlayer-module-scss-module___mQBsG__posterLayer",
  "progressFill": "NewsArticleVideoPlayer-module-scss-module___mQBsG__progressFill",
  "progressInput": "NewsArticleVideoPlayer-module-scss-module___mQBsG__progressInput",
  "progressTrack": "NewsArticleVideoPlayer-module-scss-module___mQBsG__progressTrack",
  "root": "NewsArticleVideoPlayer-module-scss-module___mQBsG__root",
  "time": "NewsArticleVideoPlayer-module-scss-module___mQBsG__time",
  "video": "NewsArticleVideoPlayer-module-scss-module___mQBsG__video",
  "volumeGroup": "NewsArticleVideoPlayer-module-scss-module___mQBsG__volumeGroup",
  "volumeSlider": "NewsArticleVideoPlayer-module-scss-module___mQBsG__volumeSlider",
  "volumeSliderWrap": "NewsArticleVideoPlayer-module-scss-module___mQBsG__volumeSliderWrap",
});
